var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconGestionRoles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14.5,
    fill: "white",
    stroke: "#394F65"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_716_5595)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4115 15.9664C12.5458 15.9627 12.9089 16.2202 13.0622 16.2949C14.7016 17.0768 17.0336 16.9741 18.5282 15.959C20.8434 16.2911 22.6885 18.0005 22.9593 20.0737C23.0181 20.5253 23.0559 20.9004 22.7221 21.2755C21.6117 22.5201 18.0286 22.9363 16.3367 22.9922C14.2943 23.0594 9.64278 22.7926 8.27628 21.2755C7.93833 20.8985 7.97611 20.5272 8.03488 20.07C8.27418 18.2729 9.73304 16.6905 11.6663 16.1344C11.8384 16.0859 12.2477 15.9702 12.4094 15.9664H12.4115Z",
    fill: "#394F65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.701 10.0167C20.6183 9.95889 20.7632 11.0561 19.8291 11.1401H11.1788C10.2384 11.0561 10.3916 9.95889 11.3068 10.0167C11.353 9.87492 11.3278 9.72003 11.3509 9.57634C11.5482 8.32794 12.3543 7.31839 13.5927 6.71751C13.6347 6.7399 13.6347 6.76416 13.6473 6.80148C13.7942 7.26987 13.7942 8.13386 14.002 8.53321C14.1322 8.78513 14.5121 8.7478 14.5751 8.48096C14.5268 7.77184 14.3022 7.07766 14.2056 6.37228C14.3064 6.18008 14.5835 6.04572 14.8186 6.02333C15.1208 5.99347 15.9311 5.98974 16.227 6.02706C16.4433 6.05318 16.8295 6.23419 16.8022 6.46372L16.4097 8.42311C16.416 8.68063 16.7959 8.80192 16.9722 8.59665C17.1842 8.00324 17.2367 7.36131 17.3794 6.74737C17.4235 6.69698 17.4214 6.72684 17.4613 6.74177C17.6754 6.82201 18.0721 7.08513 18.2548 7.22508C19.1679 7.92673 19.6569 8.94374 19.7052 10.013L19.701 10.0167Z",
    fill: "#394F65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5125 11.7656C19.5902 14.1281 17.0209 16.7219 14.2271 15.69C12.5814 15.0817 11.4395 13.335 11.492 11.7656H19.5125Z",
    fill: "#394F65"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_716_5595"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 17,
    fill: "white",
    transform: "translate(8 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGestionRoles);
export default __webpack_public_path__ + "static/media/ICON_GESTION_ROLES.cdfab67ac88bf46af6a9a777f6a2026b.svg";
export { ForwardRef as ReactComponent };